<template>
    <fieldset class="interested-in-app-fieldset" v-show="show">
        <div class="w-full flex">
            <fancy-select
                :validation-disabled="true"
                :vid="this.name + '.interestedInSecuredLoan'"
                :name="this.name + '.interestedInSecuredLoan'"
                label="If you qualified to apply for a <b>larger loan</b> at a <b>lower rate</b>, secured against your property. Would you be interested?"
                v-model="interestedInSecuredLoan"
                :options="defaultOptions"
                :rules="{ required: true, in: Object.keys(defaultOptions) }"
                :custom-messages="this.$getValidationMessages(name)"
                @input="update"
                class="mb-8"
                type="toggle"
                tooltip="In a similar way to your mortgage, you are using your property as security against the loan. Homeowner loans can be a good solution if you want to borrow a large amount of money. They are usually used to consolidate existing credit, to make home improvements or fund major purchases and as you can spread the repayments over a longer period than a personal loan, the monthly repayments can be lower. Your property is provided as security for the loan, lenders see you as less of a risk and may charge lower rates of interest. However, your home could be at risk if you are unable to repay the loan."
            ></fancy-select>
        </div>
    </fieldset>
</template>

<script>
import FancySelect from './../../components/form/fancyselect'
export default {
    inject: ['$getValidationRules', '$getValidationMessages', '$globals', '$customer'],
    watch: {
        '$globals': {
            deep: true,
            immediate: true,
            handler() {
                if (this.$globals.show_interested_in_secured_loan) {
                    this.update();
                }
            },
        },
        show(newValue) {
            console.log('Watching show');
            this.$customer.extras.interested_in_secured_loan_shown = (newValue ? 1 : 0);
        }
    },
    methods: {
        update() {
            this.$emit('input', this.interestedInSecuredLoan);
        }
    },
    computed: {
        show() {
            return this.$globals.show_interested_in_secured_loan && this.$customer.loanamount >= 10000 && this.$customer.residential_status === 'homeowner';
        }
    },
    props: {
        name: String,
        value: [String, Boolean],
        defaultOptions: Object,
        extraOptions: Object,
    },
    data() {
        return {
            interestedInSecuredLoan: null,
        }
    },
    components: {
        'fancy-select': FancySelect,
    },
}
</script>

<style lang="scss">
</style>
